import React, { useEffect, useReducer } from 'react';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { PageNotFound } from './pages/PageNotFound';
import { ProcessMaster } from './pages/process-master/ProcessMaster';
import { AppLoad } from './core/AppLoad';
import { rootReducer, AppState, AppStateContext, AppConfig } from './app-state';
import { SubMaster } from './pages/sub-master/SubMaster';
import { EventMaster } from './pages/event-master/EventMaster';
import { ListingMaster } from './pages/listing-master/ListingMaster';
import moment from 'moment-timezone';
// interface IGlobalReturn {
//     AppState: IAppState
//     updateAppState: Function
// }
export const App = (props) => {
    const [state, dispatch] = useReducer(rootReducer, AppState);
    useEffect(() => {
        document.title = `Elektronické aukce ${AppConfig.companyName}`;
        moment.tz.setDefault('Europe/Prague');
        AppLoad(AppConfig.APIUrl + 'public/auth/check').then((Response) => {
            if (Response.status == 'ok')
                dispatch({ type: 'authCheckLogged', payload: Response.userData });
            if (Response.status == 'public')
                dispatch({ type: 'authCheckPublic' });
        });
    }, []);
    return (React.createElement("div", { className: "eso-instance", key: state.instance },
        React.createElement(BrowserRouter, null,
            React.createElement(AppStateContext.Provider, { value: { state, dispatch } },
                React.createElement(Switch, null,
                    React.createElement(Route, { path: '/cs/aukce' },
                        React.createElement(EventMaster, null)),
                    React.createElement(Route, { path: '/cs/seznam' },
                        React.createElement(ListingMaster, null)),
                    React.createElement(Route, { path: '/cs/proces' },
                        React.createElement(ProcessMaster, null)),
                    React.createElement(Route, { path: '/cs/sekce' },
                        React.createElement(SubMaster, null)),
                    React.createElement(Route, null,
                        React.createElement(PageNotFound, null)))))));
};
